export default __webpack_public_path__ + "static/media/mathura.3135ebf3.jpg";